module.exports = "<div class=\"sus-wrapper\">\n  <ng-flutter assetBase=\"/assets/flutter_modernization/web/\"\n    (appLoaded)=\"onFlutterAppLoaded($event)\">\n  </ng-flutter>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/sus-feedback/sus-feedback.component.html
// module id = ../../../../../src/app/layout/home/sus-feedback/sus-feedback.component.html
// module chunks = main